export default __webpack_public_path__ + "static/media/guide33.25c9549c.png";